var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserMike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 11,
    viewBox: "0 0 10 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.91795 4.38583C9.12121 4.38583 9.2853 4.55327 9.2853 4.75959C9.2853 7.04805 7.55895 8.93197 5.36708 9.12304L5.36693 10.3405C5.36693 10.5468 5.20236 10.7143 4.99958 10.7143C4.79681 10.7143 4.63223 10.5468 4.63223 10.3405L4.63257 9.12308C2.44046 8.93225 0.713867 7.04822 0.713867 4.75959C0.713867 4.55327 0.878439 4.38583 1.08121 4.38583C1.28448 4.38583 1.44856 4.55327 1.44856 4.75959C1.44856 6.76191 3.04138 8.39148 4.99958 8.39148C6.95779 8.39148 8.5506 6.76191 8.5506 4.75959C8.5506 4.55327 8.71517 4.38583 8.91795 4.38583ZM4.99958 0C6.29901 0 7.35648 1.0799 7.35648 2.40747V4.74369C7.35648 6.07076 6.29901 7.15066 4.99958 7.15066C3.70015 7.15066 2.64268 6.07076 2.64268 4.74369V2.40747C2.64268 1.0799 3.70015 0 4.99958 0ZM4.99958 0.747508C4.10521 0.747508 3.37738 1.49203 3.37738 2.40747V4.74369C3.37738 5.65814 4.10521 6.40316 4.99958 6.40316C5.89395 6.40316 6.62179 5.65814 6.62179 4.74369V2.40747C6.62179 1.49203 5.89395 0.747508 4.99958 0.747508Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserMike);
export default __webpack_public_path__ + "static/media/userMike.124e2ce08db2ad6f12d5f3270caf43af.svg";
export { ForwardRef as ReactComponent };